import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { CovanceSelectComponent } from './covance-select.component';
import { MultilineComponent } from '../shared/multiline.component';
import { CommonModule } from '@angular/common';
import { MdlModule } from '@angular-mdl/core';
import { MdlPopoverModule } from '@angular-mdl/popover';
import { CovanceTooltipComponent } from '../shared/covance-tooltip/covance-tooltip.component';
import { MdlSelectModule } from '@angular-mdl/select';
import { CovanceMaterialModule } from '../../covance-material/covance-material.module';

@NgModule({
    declarations: [
        CovanceSelectComponent,
        MultilineComponent,
        CovanceTooltipComponent,
    ],
    imports: [
        ReactiveFormsModule,
        CommonModule,
        MdlModule,
        MdlSelectModule,
        MdlPopoverModule,
        CovanceMaterialModule,
    ],
    exports: [
        CovanceSelectComponent,
        MultilineComponent,
        CovanceTooltipComponent,
    ]
})
export class CovanceSelectModule { }